import React from "react";
import { Row, Col } from "antd";
import GridItem from "./GridItem";
import "./GridSection.css";

const GridSection = ({ categories, onCategoryClick }) => {
  // Determine desktop column span for balanced even rows
  const desktopSpan = (() => {
    const count = categories?.length || 0;
    if (count === 6) return 8; // 3 per row
    if (count === 8) return 6; // 4 per row
    return 6; // default: up to 4 per row for other counts
  })();

  if (!categories || categories.length === 0) {
    return (
      <div className="no-content">
        <p>No content available at this time. Please check back soon!</p>
      </div>
    );
  }

  return (
    <div className="grid-section">
      <Row gutter={[15, 15]} className="grid-container">
        {categories.map((category) => (
          <Col 
            key={category.id}
            xs={12}  // 2 columns on small mobile
            sm={8}   // 3 columns on mobile
            md={8}   // 3 columns on tablet
            lg={desktopSpan}
            xl={desktopSpan}
            xxl={desktopSpan}
          >
            <GridItem 
              category={category} 
              onClick={() => onCategoryClick(category.id)} 
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default GridSection;
